const companies = [
    { name: "Karimjee Jivanjee Ltd" },
    { name: "Toyota Tanzania Ltd" },
    { name: "Karimjee Value Chain Ltd" },
    { name: "Salute Finance Ltd" },
    { name: "Karimjee Jivanjee Ltd (Kenya)" },
    { name: "Karimjee Jivanjee Ltd (Uganda)" },
    { name: "City Motors Ltd" },
    { name: "International Motormart Ltd" },
  ];


  const costCenters = [
    { name: "Group Director's Office" },
    { name: "Toyota - GGM VMI 1S Branch" },
    { name: "Toyota - New Vehicles" },
    { name: "Toyota - Dar Pugu 3S Branch" },
    { name: "Group Business Improvement" },
    { name: "Lubricants" },
    { name: "Group Facilities Management" },
    { name: "Coporate" },
    { name: "Toyota OEM Wholesale Parts" },
    { name: "Group Marketing" },
    { name: "Toyota - Arusha 3S Branch" },
    { name: "Operating Lease (TZ)" },
    { name: "The Overhang" },
    { name: "Group Human Resources" },
    { name: "Group Information Technology" },
    { name: "Group Internal Audit & Sys. Mngt" },
    { name: "Family Office Functions" },
    { name: "Group Legal & Compliance" },
    { name: "Logistics" },
    { name: "Automark" },
    { name: "Group Project Management" },
    { name: "Generators (TZ)" },
    { name: "Generators (UG)" },
    { name: "Yamaha" },
    { name: "Toyota - Tanga 2S Branch" },
    { name: "Bearings" },
    { name: "Hero" },
    { name: "Generators (KE)" },
    { name: "Toyota - Mbeya 2S Branch" },
    { name: "Operating Lease (KE)" },
    { name: "Motormart" },
    { name: "Toyota Distributor Service" },
    { name: "Auto Inc. Distributor Service" },
    { name: "Group Strategy" },
    { name: "Group Supply Chain" },
    { name: "Auto Inc. Wholesale Parts" }
  ];

  
  const subCostCenters = [
    { name: "Director's Office" },
    { name: "Parts" },
    { name: "B2B" },
    { name: "B2G" },
    { name: "Body & Paint" },
    { name: "Business Improvement" },
    { name: "Commercial" },
    { name: "Construction Projects" },
    { name: "Finance & Accounts" },
    { name: "Facilities Management" },
    { name: "Fleet Management" },
    { name: "Food & Beverage" },
    { name: "Front of House" },
    { name: "Human Resources" },
    { name: "Information Technology" },
    { name: "Internal Audit & Sys. Mngt" },
    { name: "Karimjee Foundation" },
    { name: "Legal & Compliance" },
    { name: "Logistics" },
    { name: "Marketing" },
    { name: "Operations" },
    { name: "Project Management" },
    { name: "Roadside Assist" },
    { name: "Sales" },
    { name: "Service" },
    { name: "Training" },
    { name: "Strategy" },
    { name: "Supply Chain" },
    { name: "Tyres & Batteries" },
    { name: "Value +" }
  ];
  
  const leaders = [
    { name: "Jatin Mahendra Pandya" },
    { name: "Amit Kumar Singh" },
    { name: "Farishta Kohli" },
    { name: "Rishad Mahmood Karimjee" },
    { name: "Vinod Rustagi" },
    { name: "Jasmine Mahmood Karimjee" },
    { name: "Sanjay Bhikchand Mundade" },
    { name: "Jacobus Albertus Van Zyl" },
  ]


  export { companies, costCenters, subCostCenters, leaders };